module.exports = __webpack_public_path__ + "static/media/passarosetecores-partitura.459a6a87.png";